<script lang=ts>
  let { class: className = ""} = $props()
</script>


<svg
	height="24px"
	class="w-full h-full aspect-square {className}"
	viewBox="0 -960 960 960"
	width="24px"
	><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" /></svg
>
